import React from 'react';
import PreForm from "../../components/passengerInformation/PreForm";
import BackLink from "../../components/BackLink";
import usePreCruisePassenger from "../../hooks/usePreCruisePassenger";
import { Trans, useLingui } from '@lingui/react/macro';

function PassengerOverview(props) {
    const {passengerId, type} = props.params;
    const passenger = usePreCruisePassenger(passengerId);
    const {t} = useLingui();

    const isMedicalMobilityPage = type === "medicalAndMobility";

    return (
        <div className="container mx-auto">
            <div className="mt-4">
                {isMedicalMobilityPage ? (
                    <BackLink to={t({id: "/precruise/passengers"}) + "/medicalAndMobility"} text={t({id: "back_to_medical_and_mobility_information_dashboard"})} />
                ) : (
                    <BackLink to={t({id: "/precruise/passengers"})} text={t({id: "back_to_travel_information_dashboard"})} />
                )}
            </div>
            <h1>
                {isMedicalMobilityPage ? (
                    <Trans id="m_and_m_information_for">Medical and Mobility Information for</Trans>
                ) : (
                    <Trans id="travel_information_for">Travel Information for</Trans>
                )}
                {' '}{passenger.firstName} {passenger.lastName}
            </h1>

            <PreForm passenger={passenger} isMedicalMobilityPage={isMedicalMobilityPage} />
        </div>
    )
}

export default PassengerOverview;



